import { createStyles, makeStyles } from "@material-ui/core";
import { COLORS } from "../../../config/theme/theme";

export const userStyles = makeStyles(() =>
  createStyles({
    // header start
    container: {
      marginTop: "80px",
      padding: "24px",
    },
    heading: {
      fontWeight: 600,
      fontSize: "24px",
      color: COLORS.DARK_GRAY,
      margin: "auto 0px",
    },
    configDetailsDiv: {
      padding: 0,
      margin: 0,
      marginTop: "24px",
    },
    // header end

    // mainContent Start
    accordionStyle: {
      background: COLORS.WHITE,
      border: "1px solid #C3C3C3",
      borderRadius: "4px",
      marginTop: "12px",
      "&:last-child": {
        padding: 0,
        margin: 0,
        marginTop: "12px",
      },
    },
    accordionSummaryStyle: {
      padding: "12px 24px 12px 12px",
    },
    accordionTitle: {
      fontSize: "18px",
      fontWeight: 600,
    },
    accordionDetailsStyle: {
      borderTop: "1px solid #C3C3C3",
      display: "block",
      padding: "12px 0px 12px 0px",
    },
    dlvFeeServiceTypeDiv: {
      margin: "0px 0px 16px 0px",
      padding: "8px 12px",
      background: COLORS.DOS_BLUE_SUPER_LIGHT,
      "&:last-child": {
        margin: "0px",
      },
    },
    dlvFeeServiceTypeTextDivStyle: {
      margin: 0,
      padding: "12px 0px 12px 0px",
    },
    dlvFeeServiceTypeTextStyle: {
      margin: "auto",
      padding: 0,
      color: COLORS.BLACK,
      fontSize: "18px",
      fontWeight: 600,
    },
    thresholdInputMainDiv: {
      margin: 0,
      padding: 0,
      paddingTop: "12px",
      display: "flex",
      justifyContent: "flex-start",
      "&:first-child": {
        padding: "0px",
      },
    },
    thresholdInputDiv: {
      paddingRight: "12px",
    },
    addConfigIconMainDivStyle: {
      width: "100%",
      height: "100%",
    },
    addConfigIconDivStyle: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-start",
      cursor: "pointer",
    },
    addConfigIconDivStyleDisabled: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-start",
      cursor: "default",
      opacity: "0.5",
    },
    addConfigIconStyle: {
      margin: "auto 0px",
      width: "20px",
      height: "20px",
      color: COLORS.PRIMARY_MAIN,
    },
    addConfigTextStyle: {
      color: COLORS.PRIMARY_MAIN,
      fontSize: "12px",
      fontWeight: 500,
      margin: "auto 0px auto 12px",
    },
    disableSwitch: {
      opacity: 0.5,
    },
    switchStyle: {},
    marginAuto: {
      margin: "auto",
    },
    useCalculationTextdivStyle: {
      margin: 0,
      marginRight: "12px",
      textAlign: "right",
    },
    innerAccordionMaindiv: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "space-between",
    },
    // mainContent end

    // footer start
    configButtonDiv: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "24px 0px",
    },
    cancelConfigStyle: {
      width: "212px",
      background: "#FFFFFF",
      border: "1px solid #0E5AA7",
      borderRadius: "4px",
      color: "#0E5AA7",
      textDecoration: "none",
      textTransform: "none",
      marginRight: "24px",
      "&:hover": {
        background: "#FFFFFF",
        border: "1px solid #0E5AA7",
      },
      "&.MuiButton-label": {
        background: "#FFFFFF",
        border: "1px solid #0E5AA7",
        "&:hover": {
          background: "#FFFFFF",
          border: "1px solid #0E5AA7",
        },
      },
    },
    previewAndUpdateConfigStyle: {
      width: "300px",
      background: "#0E5AA7",
      border: "1px solid #0E5AA7",
      borderRadius: "4px",
      color: "#FFFFFF",
      textDecoration: "none",
      textTransform: "none",
      "&:hover": {
        background: "#0E5AA7",
        border: "1px solid #0E5AA7",
      },
      "&.MuiButton-label": {
        background: "#0E5AA7",
        border: "1px solid #0E5AA7",
        "&:hover": {
          background: "#0E5AA7",
          border: "1px solid #0E5AA7",
        },
      },
    },
    actionIconDivStyle: {
      margin: 0,
      marginTop: "auto",
      marginBottom: "auto",
      padding: 0,
    },
    actionIconStyle: {
      cursor: "pointer",
    },
    // footer end

    // AdditionalDeliveryFeeConfigList start
    additionDlvFeeMainCard: {
      margin: 0,
      padding: "12px 0px 12px 0px",
      width: "100%",
      height: "auto",
      boxShadow: "none",
      background: "none",
    },
    additionDlvFeeMainTitleDivStyle: {
      margin: 0,
      padding: 0,
    },
    additionDlvFeeMainTitleStyle: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "20px",
      color: COLORS.COD_GRAY,
    },
    additionDlvFeeInnerCardStyle: {
      margin: 0,
      padding: "0px",
      width: "100%",
      height: "auto",
      boxShadow: "none",
      background: "none",
    },
    additionDlvFeeInnerTitleDivStyle: {
      margin: 0,
      padding: "12px 0px 12px 0px",
      width: "100%",
      height: "auto",
    },
    additionDlvFeeInnerTitleTextStyle: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "20px",
      color: COLORS.COD_GRAY,
    },
    additionDlvFeeInnerRowHeaderStyle: {
      margin: 0,
      padding: "8px 0px 0px 0px",
      width: "100%",
      height: "auto",
      boxShadow: "none",
    },
    dlvFeeValueDisplayDivStyle: {
      margin: "auto 0px",
      padding: 0,
    },
    dlvFeeValueDisplayTitleStyle: {
      fontWeight: 500,
      fontSize: "12px",
      color: COLORS.COD_GRAY,
    },
    additionDlvFeeInnerRowHeaderTextStyle: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "17px",
      color: "#2D2D2D",
    },
    additionDlvFeeInnerRowBodyStyle: {
      margin: 0,
      padding: "12px 0px 0px 0px",
      width: "100%",
      height: "auto",
      boxShadow: "none",
    },
    additionDlvFeeInnerRowDivStyle: {
      margin: 0,
      marginTop: "auto",
      marginBottom: "auto",
      padding: 0,
      paddingRight: "12px",
    },
    additionDlvFeeInnerRowBodyTextStyle: {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "17px",
      color: "#2D2D2D",
    },
    // AdditionalDeliveryFeeConfigList end

    // changes for Threshold range
    dlvFeeCalculationDivStyle: {
      margin: "auto",
      padding: 0,
      textAlign: "right",
    },
    dlvFeeCalculationTextStyle: {
      fontWeight: 400,
      fontSize: "14px",
      color: "#141414",
      margin: "auto 12px",
    },
    dlvFeeCalculationTextBoldStyle: {
      fontWeight: 600,
      fontSize: "14px",
      color: "#0E5AA7",
      margin: "auto 12px",
    },
    multiDlvFeePercentageCalculationTextStyle: {
      fontWeight: 400,
      fontSize: "14px",
      color: "#141414",
      margin: "auto 12px auto -6%",
    },
    multiDlvFeePercentageCalculationTextBoldStyle: {
      fontWeight: 600,
      fontSize: "14px",
      color: "#0E5AA7",
      margin: "auto 12px auto -6%",
    },
    useCalculationDivStyle: {
      textAlign: "right",
    },
    addConfigurationInputDivStyle: {
      margin: 0,
      padding: 0,
      paddingTop: "12px",
      display: "flex",
      justifyContent: "flex-start",
    },
    textAlignLeft: {
      textAlign: "left",
    },

    // multi-shipment Content
    multiShipmentButtonDiv: {
      display: "flex",
      justifyContent: "flex-end",
      margin: 0,
      padding: 0,
    },
    multiShipmentButtonStyle: {
      margin: 0,
      padding: 0,
      width: "340px",
      background: "#FFFFFF",
      border: "1px solid #0E5AA7",
      borderRadius: "4px",
      color: "#0E5AA7",
      textDecoration: "none",
      textTransform: "none",
      "&:hover": {
        background: "#FFFFFF",
        border: "1px solid #0E5AA7",
      },
      "&:disabled": {
        background: "#FFFFFF",
        border: "1px solid #B2B2B2",
        opacity: "0.5",
      },
      "&.MuiButton-label": {
        background: "#FFFFFF",
        border: "1px solid #0E5AA7",
        "&:hover": {
          background: "#FFFFFF",
          border: "1px solid #0E5AA7",
        },
      },
    },
    shipmentLevelButtonStyle: {
      margin: 0,
      padding: 0,
      width: "340px",
      background: "#0E5AA7",
      border: "1px solid #0E5AA7",
      borderRadius: "4px",
      color: "#FFFFFF",
      textDecoration: "none",
      textTransform: "none",
      "&:hover": {
        background: "#0E5AA7",
        border: "1px solid #0E5AA7",
      },
      "&:disabled": {
        background: "#CFD8DC",
        border: "1px solid #B2B2B2",
        opacity: "0.5",
      },
      "&.MuiButton-label": {
        background: "#0E5AA7",
        border: "1px solid #0E5AA7",
        "&:hover": {
          background: "#0E5AA7",
          border: "1px solid #0E5AA7",
        },
      },
    },
    textAlignRight: {
      textAlign: "right",
    },
    percentageBasedDivStyle: {
      display: "flex",
      justifyContent: "flex-end",
    },
    multi_shipment_tooltip_style: {
      background: "#FFFFFF",
      minWidth: "380px",
      padding: "8px",
      margin: "8px 0px",
      border: "1px solid #FFFFFF",
      borderRadius: "4px",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    },
    multi_shipment_tooltip_arrow_style: {
      color: "#FFFFFF",
    },
    tooltipStyle: {
      ontWeight: 500,
      fontSize: "8px",
      lineHeight: "16px",
      color: "#2D2D2D",
    },
    multiShipmentDlvFeeServiceTypeTextDivStyle: {
      margin: 0,
      padding: "12px 0px 0px 0px",
    },
    drawerCheckBoxInputMainDiv: {
      margin: 0,
      padding: 0,
      paddingBottom: "12px",
      display: "flex",
      justifyContent: "flex-start",
      "&:first-child": {
        padding: "0px",
      },
    },
    drawerCheckBoxDiv: {
      margin: "auto",
    },
    checkboxLabel: {
      fontWeight: 400,
      fontSize: "12px",
      color: "#252525",
      margin: "auto 8px",
    },
    drawerConfigSpanLabel: {
      fontWeight: 500,
      fontSize: "12px",
      color: COLORS.COD_GRAY,
      margin: "auto 8px",
    },
    dlvFeeValueDisplayDataStyle: {
      fontFamily: "Montserrat",
      fontWeight: 500,
      color: "#141414",
      fontSize: "14px",
      lineHeight: "20px",
    },
    serviceTypeItem: {},
    dlvFeeStatusTextStyle: {
      fontWeight: 600,
      fontSize: "14px",
      color: "#141414",
      margin: "0",
      textAlign: "start",
    },
    addServiceFeeIconDivStyle: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
      cursor: "pointer",
    },
    addServiceFeeIconDivStyleDisabled: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
      cursor: "default",
      opacity: "0.5",
    },

    // Express Service Fee start
    expressServiceFeeDlvFeeMainCard: {
      margin: "8px 0px 0px 0px",
      padding: "8px",
      width: "100%",
      height: "auto",
      boxShadow: "none",
      background: COLORS.DOS_BLUE_LIGHT,
      borderRadius: "12px",
    },
    congigurationCardStyle: {
      margin: 0,
      padding: "16px",
      height: "auto",
      width: "100%",
      boxShadow: "none",
      borderRadius: "8px",
      background: COLORS.DOS_BLUE_LIGHT,
    },
    addInnerConfigIconDivStyle: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-start",
      cursor: "pointer",
    },
    addInnerConfigIconDivStyleDisabled: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-start",
      cursor: "default",
      opacity: "0.5",
    },
    addThresholdRangeConfigIconStyle: {
      margin: "auto 0px",
      width: "20px",
      height: "20px",
      color: COLORS.DOS_BLUE_DARK,
      cursor: "pointer",
    },
    addThresholdRangeConfigTextStyle: {
      color: COLORS.DOS_BLUE_DARK,
      fontSize: "12px",
      fontWeight: 500,
      margin: "auto 0px auto 8px",
    },
    drawerConfigurationInputDiv: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
    },
    editPencilActionIconStyle: {
      margin: 0,
      padding: "0px 16px 0px 16px",
      cursor: "pointer",
    },
    dlvServiceFeeDesignInputDiv: {
      margin: 0,
      padding: "8px 0px 0px 0px",
    },
    dFlexEnd: {
      margin: "auto",
      display: "flex",
      justifyContent: "flex-end",
    },
    marginAutoDisabled: {
      margin: "auto",
      opacity: "0.5",
    },
    serviceFeeFlexStartInputMainDiv: {
      margin: 0,
      padding: 0,
      paddingTop: "12px",
      display: "flex",
      justifyContent: "flex-start",
      "&:first-child": {
        padding: "0px",
      },
    },
    serviceFeeFlexEndInputMainDiv: {
      margin: 0,
      padding: 0,
      paddingTop: "12px",
      display: "flex",
      justifyContent: "flex-end",
      "&:first-child": {
        padding: "0px",
      },
    },
    errorMessageSpanStyle: {
      color: COLORS.DARK_RED,
      fontSize: "10px",
      fontWeight: 400,
      margin: "12px 8px 0px 0px",
    },
    disabledDrawerConfigurationInputDiv: {
      margin: 0,
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
      opacity: "0.5",
    },
    configDateTextStyle: {
      margin: 0,
      marginBottom: "12px",
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "17px",
      color: COLORS.TUATARA,
    },
    configDateNoteTextStyle: {
      margin: 0,
      marginBottom: "8px",
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "17px",
      color: COLORS.PRIMARY_MAIN,
      float: "right",
    },
    capacityUtilisationValueDiv: {
      margin: 0,
      padding: "0px 0px 8px 0px",
    },
    rightPaddingStyle: {
      paddingRight: "12px",
    },
    promiseSlotDetailsButton: {
      margin: "auto 0px",
    },
    additionConfigDlvFeeMainCard: {
      margin: "16px 0px 0px 0px",
      padding: 0,
      width: "100%",
      height: "auto",
      boxShadow: "none",
      background: COLORS.DOS_BLUE_SUPER_LIGHT,
      border: "none",
      borderRadius: "4px",
    },
    additionDlvFeeTitleItemDivStyle: {
      margin: 0,
      padding: "0px 0px 8px 0px",
    },
    additionDlvFeeInnerRowItemStyle: {
      margin: "0px 0px 8px 0px",
      padding: 0,
      width: "100%",
      height: "auto",
      boxShadow: "none",
    },
    configDateNoteGridItemStyle: {
      margin: "auto 0px",
      padding: 0,
    },
    noDataTextStyle: {
      color: COLORS.DARK_RED,
      fontSize: "14px",
      fontWeight: 400,
      margin: "12px 8px 0px 0px",
    }
  })
);
